import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from '@themesberg/react-bootstrap';
import { useCookies } from "react-cookie";
import { editMegaResults } from "../../../../../controller/api/gameResult";

export default (props) => {

  const [cookies] = useCookies(['lottmekong'])

  const [numbers, setNumbers] = useState(['', '', '', '', '', ''])

  const _onHide = () => {
    setNumbers(['', '', '', '', '', ''])
    props.onHide()
  }

  // Load existing result when popup opens
  useEffect(() => {
    if (props.result && props.result.length > 0 && props.show) {
      const resultString = props.result[0] || props.result
      const nums = typeof resultString === 'string' ? resultString.split(' ') : []
      setNumbers([
        nums[0] || '',
        nums[1] || '',
        nums[2] || '',
        nums[3] || '',
        nums[4] || '',
        nums[5] || ''
      ])
    }
  }, [props.result, props.show])

  const handleNumberChange = (index, value) => {
    const newNumbers = [...numbers]
    newNumbers[index] = value
    setNumbers(newNumbers)
  }

  const onSubmit = async () => {
    // Validate all 6 numbers are entered
    const validNumbers = numbers.filter(n => n && n.length > 0)
    if (validNumbers.length !== 6) {
      alert('Vui lòng nhập đầy đủ 6 số')
      return
    }

    const resp = await editMegaResults(cookies.lottmekong, props.period.id, numbers)
    if (resp) {
      window.location.reload()
    } else {
      alert('Có lỗi xảy ra')
      return false
    }
  }

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={_onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Sửa kết quả Mega 6/45 - Kỳ #{props.period && props.period.name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {[0, 1, 2, 3, 4, 5].map((idx) => (
            <Form.Group key={idx} className="mb-3">
              <Form.Label>Số {idx + 1}</Form.Label>
              <Form.Control
                type="text"
                placeholder={`Nhập số ${idx + 1}`}
                value={numbers[idx]}
                onChange={(e) => handleNumberChange(idx, e.target.value)}
              />
            </Form.Group>
          ))}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={_onHide}>Close</Button>
        <Button variant="primary" onClick={onSubmit}>Cập nhật</Button>
      </Modal.Footer>
    </Modal>
  );
}























